<template>
  <div>
    <md-toolbar class="md-primary nav-style first-nav">
      <img src="@/assets/logo.png" class="logo_navbar" />
      <div class="md-toolbar-section-end nav-style">
        <language-picker></language-picker>
      </div>
    </md-toolbar>
    <div class="md-title second-navbar">{{ $t("message.title") }}</div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import LanguagePicker from "../language-picker/LanguagePicker.vue";
export default {
  components: { LanguagePicker },
  name: "main-header",
  data() {
    return {};
  }
};
</script>
<style scoped>
.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}
.person-icon {
  color: #027953;
}
.first-nav {
  background-color: #ffffff !important;
}
.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.nav-style {
  height: 50px;
}
.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.title-style {
  color: #027953;
}

.first-nav {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/MainHeader.vue